import request from '@/util/request'
import colors from 'vuetify/es5/util/colors'

const state = {
  mode: 'light',
  themeColor: 'pink',
  lang: window.localStorage.getItem('language') || 'lt',
}

// getters
const getters = {
  getThemeColor: state => {
    return colors[state.themeColor].base
  },
  language: state => {
    return state.lang
  },
}

// actions
const actions = {
  setLanguage({ commit }, payload) {
    commit('SET_LANGUAGE', payload)
  },
}

// mutations
const mutations = {
  setThemeColor(state, payload) {
    state.themeColor = payload
  },
  SET_LANGUAGE(state, payload) {
    window.localStorage.setItem('language', payload.lang)
    payload.i18n.locale = payload.lang
    state.lang = payload.lang
    return request({
      url: '/change-language',
      method: 'post',
      data: {
        language: payload.lang,
      },
    })
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
